import dayjs, { Dayjs } from 'dayjs';
import _ from 'lodash';
import React, { ReactElement, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import AccountTypeEnum from '~Api/Investor/AccountTypeEnum';
import IAccount from '~Api/Investor/IAccount';
import IAnnualStatement from '~Api/Investor/IAnnualStatement';
import {
    annualStatementsListAction,
    currentInvestorGetAction,
} from '~Investor/actions';
import {
    currentInvestorAccountAnnualStatementsSelector,
    currentInvestorAccountSelector,
} from '~Investor/selectors';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';

export default function AnnualStatementAlert(props: {
    accountType: AccountTypeEnum;
}): ReactElement {
    const { accountType } = props;

    const annualStatements: IDictionary<IAnnualStatement> = useSelector((state: IGlobalState) => currentInvestorAccountAnnualStatementsSelector(state, accountType));
    const investorAccount: IAccount = useSelector((state: IGlobalState) => currentInvestorAccountSelector(state, accountType));

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!investorAccount) {
            dispatch(currentInvestorGetAction());
        }
    }, []);

    useEffect(() => {
        if (!annualStatements) {
            dispatch(annualStatementsListAction(accountType));
        }
    }, []);

    if (!annualStatements || !investorAccount) {
        return null;
    }

    const currentDate: Dayjs = dayjs().tz('Australia/Brisbane');
    const statementYear: number = currentDate.month() >= 6 ? currentDate.year() : currentDate.year() - 1;
    const financialYearEnd: Dayjs = dayjs.tz(`${statementYear}-07-01`, 'Australia/Brisbane');
    const isEligibleForStatementYear: boolean = dayjs(investorAccount.createdTime).tz('Australia/Brisbane').isBefore(financialYearEnd);

    if (!isEligibleForStatementYear) {
        return null;
    }

    const hasStatement: boolean = _.some(annualStatements, (annualStatement: IAnnualStatement) => Number(annualStatement.year) === statementYear);

    if (!hasStatement) {
        return (
            <Alert>
                <Alert.Heading>Annual Income Statement available soon</Alert.Heading>
                <p>Your Annual Income Statements for the year ended 30 June {statementYear} are currently being processed.</p>
                <p>Thank you for your patience and your continued support during FY{statementYear}.</p>
            </Alert>
        );
    }

    return (
        <Alert>
            <Alert.Heading>Annual Income Statement available now</Alert.Heading>
            <p>Your Annual Income Statements for the year ended 30 June {statementYear} are now available for you to download.</p>
        </Alert>
    );
}
